(function () {
  'use strict';

  function initialize() {
    var mobile = window.matchMedia('(max-width: 1023px)');
    document.querySelectorAll('body.template-product .single-product .grid, body.template-product .bioss-assay__layout').forEach(function (grid) {
      if (grid.dataset.biossProductOrderReady) return;
      var section = grid.closest('.single-product');
      var aside = grid.querySelector(':scope > .product-aside');
      var images = grid.querySelector(':scope > .product-images');
      if (!section || !aside || !aside.querySelector('.purchase-box')) return;
      var heading = section.querySelector('.product-header');
      var sku = aside.querySelector('.product-tabs .sku:not(#openPopupButton)');
      var gallery = images && images.querySelector('.images-container, .bioss-assay__gallery');
      var packaging = grid.querySelector(':scope > .bioss-assay__packaging');

      function columnPart(column, selector) {
        if (!column) return null;
        var node = column.querySelector(selector);
        if (!node) return null;
        while (node.parentElement !== column) {
          node = node.parentElement;
          if (!node) return null;
        }
        return node;
      }

      var entries = [
        { node: heading, name: 'heading' },
        { node: packaging, name: 'packaging' },
        { node: gallery, name: 'gallery' },
        { node: aside, name: 'purchase' },
        { node: images, name: 'details' },
        { node: columnPart(aside, '[data-bioss-product-distributor-finder]'), name: 'international' },
        { node: columnPart(aside, '.pf-cf83f501a465-10_'), name: 'promo' },
        { node: columnPart(aside, '[data-bioss-lab-essentials], .pf-8846aeb6c091-7_'), name: 'recommendations' },
        { node: columnPart(aside, '.bioss-product-page-citations-cta'), name: 'citation-link' },
        { node: columnPart(images, '[data-bioss-citeab-section]'), name: 'citations' },
        { node: columnPart(aside, '.guarantee'), name: 'guarantee' }
      ].filter(function (entry) { return entry.node; });
      entries.forEach(function (entry) {
        entry.anchor = document.createComment('bioss-product-order-' + entry.name);
        entry.node.parentNode.insertBefore(entry.anchor, entry.node);
      });
      var skuAnchor;
      if (sku && heading) {
        skuAnchor = document.createComment('bioss-product-order-sku');
        sku.parentElement.insertBefore(skuAnchor, sku);
      }
      var galleryGroup = document.createElement('div');
      galleryGroup.className = 'product-images bioss-product-gallery-group';
      galleryGroup.setAttribute('data-bioss-product-part', 'gallery');
      var citationGroup = document.createElement('div');
      citationGroup.setAttribute('data-bioss-product-part', 'citations');
      var active = false;

      function sync() {
        if (mobile.matches === active) return;
        if (mobile.matches) {
          if (skuAnchor) heading.appendChild(sku);
          entries.forEach(function (entry) {
            if (entry.name === 'gallery') {
              var description = entry.node.nextElementSibling;
              galleryGroup.appendChild(entry.node);
              if (description && description.classList.contains('bioss-mobile-gallery__description')) galleryGroup.appendChild(description);
              grid.appendChild(galleryGroup);
            } else if (entry.name === 'citation-link' || entry.name === 'citations') {
              if (!citationGroup.parentNode) grid.appendChild(citationGroup);
              citationGroup.appendChild(entry.node);
            } else {
              entry.node.setAttribute('data-bioss-product-part', entry.name);
              grid.appendChild(entry.node);
            }
          });
          grid.setAttribute('data-bioss-mobile-product-order', '');
        } else {
          entries.forEach(function (entry) {
            entry.anchor.parentNode.insertBefore(entry.node, entry.anchor.nextSibling);
            entry.node.removeAttribute('data-bioss-product-part');
            if (entry.name === 'gallery') {
              var description = galleryGroup.querySelector('.bioss-mobile-gallery__description');
              if (description) entry.node.insertAdjacentElement('afterend', description);
            }
          });
          if (skuAnchor) skuAnchor.parentNode.insertBefore(sku, skuAnchor.nextSibling);
          galleryGroup.remove();
          citationGroup.remove();
          grid.removeAttribute('data-bioss-mobile-product-order');
        }
        active = mobile.matches;
        window.dispatchEvent(new Event('resize'));
      }
      grid.dataset.biossProductOrderReady = 'true';
      mobile.addEventListener('change', sync);
      sync();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();

(function () {
  'use strict';

  function initializeGallery() {
    var mobile = window.matchMedia('(max-width: 1023px)');
    var labels = { view: 'View image description', hide: 'Hide image description', previous: 'Previous product image', next: 'Next product image' };
    var config = document.querySelector('[data-bioss-mobile-product-config]');
    if (config) {
      try { Object.assign(labels, JSON.parse(config.textContent)); } catch (_) {}
    }
    document.querySelectorAll('body.template-product #product-featured-image').forEach(function (gallery, index) {
      if (gallery.dataset.biossMobileGalleryReady) return;
      gallery.dataset.biossMobileGalleryReady = 'true';
      gallery.classList.add('bioss-mobile-gallery');
      if (!gallery.id) gallery.id = 'bioss-product-gallery-' + index;

      var controls = document.createElement('div');
      controls.className = 'bioss-mobile-gallery__controls';
      controls.hidden = true;
      ['Previous', 'Next'].forEach(function (direction) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'bioss-mobile-gallery__arrow';
        button.setAttribute('aria-label', direction === 'Previous' ? labels.previous : labels.next);
        button.setAttribute('aria-controls', gallery.id);
        button.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true"><path d="' + (direction === 'Previous' ? 'M14 5l-7 7 7 7' : 'M10 5l7 7-7 7') + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (gallery.slick && gallery.classList.contains('slick-initialized')) {
            gallery.slick[direction === 'Previous' ? 'slickPrev' : 'slickNext']();
          }
        });
        controls.appendChild(button);
      });
      (gallery.closest('.images-container') || gallery.parentElement).appendChild(controls);

      var description = document.createElement('details');
      description.className = 'bioss-mobile-gallery__description';
      var summary = document.createElement('summary');
      summary.textContent = labels.view;
      var content = document.createElement('div');
      content.className = 'bioss-mobile-gallery__description-text';
      description.appendChild(summary);
      description.appendChild(content);
      var container = gallery.closest('.images-container') || gallery;
      container.insertAdjacentElement('afterend', description);
      description.addEventListener('toggle', function () {
        summary.textContent = description.open ? labels.hide : labels.view;
      });

      function sync(event) {
        var current = gallery.querySelector('.slick-current') || gallery.querySelector('.product-image');
        var image = current && current.querySelector('img');
        var caption = current && current.querySelector('.caption');
        var text = caption ? caption.textContent.trim() : (image ? image.getAttribute('alt') || '' : '');
        content.textContent = text;
        description.hidden = !text || !!(current && current.classList.contains('bioss-published-slide'));
        if (event && event.type === 'afterChange') description.open = false;
        var ready = gallery.classList.contains('slick-initialized');
        var count = ready && gallery.slick ? gallery.slick.slideCount : 0;
        controls.hidden = !ready || count < 2 || !!container.querySelector('.bioss-published-controls');
      }
      function bindCarousel() {
        if (!gallery.slick || !gallery.classList.contains('slick-initialized')) return false;
        gallery.slick.$slider.off('.biossMobileGallery').on('reInit.biossMobileGallery afterChange.biossMobileGallery', sync);
        sync();
        return true;
      }
      if (!bindCarousel()) {
        var observer = new MutationObserver(function () {
          if (bindCarousel()) observer.disconnect();
        });
        observer.observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      }
      mobile.addEventListener('change', function () {
        description.open = false;
        sync();
      });
      sync();
      if (gallery.slick && gallery.classList.contains('slick-initialized')) {
        gallery.slick.setPosition();
      }
      window.addEventListener('load', sync, { once: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGallery, { once: true });
  } else {
    initializeGallery();
  }
  document.addEventListener('shopify:section:load', initializeGallery);
})();
